import React, { useState } from 'react';
import { find } from 'lodash';
import config from '../../../../config';

import CheckBox from './CheckBox';

import styles from './withdraw.scss';
import { paymentStatusTypeIds } from '../../../utils/eventConstants';

const _ = { find };

const WithdrawPopup = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { player, withdrawRefund, withdrawType, currentDivisionId, showWithdrawRefund, verifiedEvent, allowOffPlatformPayments } = props;

    const { refundable, divisions } = player;
    const playerDivision = _.find(divisions, { id: currentDivisionId });
    const paymentPending = playerDivision?.paymentStatusTypeId === paymentStatusTypeIds.PENDING;

    const isWithdrawType = withdrawType === 'withdraw';

    const getButtonLabel = () => {
        if (isSubmitting) {
            return isWithdrawType ? 'Withdrawing...' : 'Refunding...';
        }
        return isWithdrawType ? 'Withdraw' : 'Refund';
    };

    const handleConfirmClick = () => {
        setIsSubmitting(true);
        props.confirmPopup();
    };

    return (
        <div className={styles.popup} data-testid="modal.withdraw-popup">
            <div
                className={`${styles.popup_inner}`}
                style={props.topPoint ? {
                    top: props.topPoint.toString(),
                    transform: `translateX(-50%) translateY(-50%)`,
                } : {}}
            >
                <div className={`${styles.popupContent}`}>
                    {withdrawType === 'withdraw' && (
                        !paymentPending ? (
                            <>
                                <h5 className={`title-uppercase`}>
                                    Withdraw {player.firstName} {player.lastName}
                                </h5>
                                <form className={`space-top mt20`}>
                                    <ul>
                                        <li className={`${styles.popupText}`}>
                                            This will remove the player from all divisions in this event.
                                        </li>
                                        {(!(verifiedEvent && !showWithdrawRefund) || (verifiedEvent && !showWithdrawRefund)) && (!allowOffPlatformPayments) && (
                                            <li className={`${styles.popupText}`}>
                                                {!(verifiedEvent && !showWithdrawRefund) && (
                                                    <>
                                                        You also have the option of refunding their entry fees below.
                                                    </>
                                                )}
                                                {(verifiedEvent && !showWithdrawRefund) && (
                                                    <>
                                                        If the player paid a Verified Event fee to UTR Sports, it will automatically be refunded.
                                                    </>
                                                )}
                                            </li>
                                        )}
                                        <li className={`${styles.popupText}`}>
                                            If you only want to withdraw the player from specific divisions, you must withdraw
                                            them from the entire event and have them re-register for the specific divisions.
                                        </li>
                                        <li className={`${styles.popupText}`}>
                                            If withdrawing from a doubles division, the player`s partner will also be withdrawn from the event.
                                        </li>
                                    </ul>
                                    {showWithdrawRefund && (
                                        <>
                                            <CheckBox
                                                colClass="mt8"
                                                item={{ isSelected: withdrawRefund, name: 'Refund entry fees' }}
                                                onChanged={props.onRefundCheckSelectionChange}
                                                disabled={!refundable}
                                            />
                                            {!refundable && (
                                                <div className={`mt8`}>
                                                    This payment is older than sixty days and cannot be refunded on {`${config.siteBaseUrl}`}. Please refund the player in person or through another medium.
                                                </div>
                                            )}
                                        </>
                                    )}
                                </form>
                                <div className={`${styles.warningText} mt20`}>
                                    Player will be entirely removed from the event but can re-register afterwards.
                                </div>
                            </>
                        ) : (
                            <>
                                <h5 className={`title-uppercase`}>
                                    Withdraw {player.firstName} {player.lastName}
                                </h5>
                                <div>
                                    Please wait for this player`s payment status to fully process before withdrawing them.
                                    Contact our <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`}>support team</a> for
                                    assistance if the player has been registered for over a day but their payment status is still pending.
                                </div>
                            </>
                        )
                    )}
                    {withdrawType === 'refund' && (
                        <>
                            <h5 className={`title-uppercase`}>
                                Refund Entry Fees
                            </h5>
                            {
                                !paymentPending ? (
                                    <div className={`space-top mt20`}>
                                        {(() => {
                                            if (!refundable) {
                                                return `This payment is older than sixty days and cannot be refunded on ${config.siteBaseUrl}. Please refund the player in person or through another medium.`;
                                            }
                                            return `You will refund fees for all divisions that the player registered and paid for, including any doubles divisions. This will not change the player's registration status.`;
                                        })()}
                                    </div>
                                ) : (
                                    <div className={`space-top mt20`}>
                                        Please wait for this player`s payment status to fully process before withdrawing them.
                                        Contact our <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`}>support team</a> for
                                        assistance if the player has been registered for over a day but their payment status is still pending.
                                    </div>
                                )
                            }
                        </>
                    )}
                </div>
                {
                    (!paymentPending && (withdrawType === 'withdraw' || (withdrawType === 'refund' && refundable))) ? (
                        <div className={`text-right ${styles.popupFooter}`}>
                            <button
                                type="button"
                                className={`btn btn-default btn-sm text-uppercase`}
                                onClick={props.closePopup}
                                disabled={isSubmitting}
                                data-testid="modal.withdraw-popup.cancel-btn"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className={`btn btn-primary btn-sm text-uppercase ${styles.btnWithdraw}`}
                                onClick={handleConfirmClick}
                                disabled={isSubmitting}
                                data-testid="modal.withdraw-popup.confirm-btn"
                            >
                                {getButtonLabel()}
                            </button>
                        </div>
                    ) : (
                        <div>
                            <div className={`text-right ${styles.popupFooter}`}>
                                <button
                                    type="button"
                                    className={`btn btn-default btn-sm text-uppercase`}
                                    onClick={props.closePopup}
                                    data-testid="modal.withdraw-popup.got-it-btn"
                                >
                                    Got it
                                </button>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default WithdrawPopup;
